export default "__VITE_ASSET__BTGjCGXv__"